import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

function getUrl(code) {
  return `v1/stock/detail/${code}/about/`;
}

/**
 * @param {string} url
 * @returns
 */
function callbackFetch(url) {
  return async () => {
    try {
      /** @type {import('./typedefs').Response} */
      const res = await fetcher.get(url);

      return res.data;
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}

/**
 * @param {string} stockCode
 */
export default function fetch(stockCode) {
  const url = getUrl(stockCode);
  const cb = callbackFetch(url);
  const key = [url];

  return { cb, key };
}
